/* Get a query string from an object */

const getQueryString = (params) =>
  Object.keys(params)
    .map((key) => key + '=' + encodeURIComponent(params[key]))
    .join('&');

export default getQueryString;
